"use client"
import { Drawer } from "@/components/ui/Drawer"
import { IconButton } from "@/components/ui/IconButton"
import { useDisclosure } from "@/lib/hooks/useDisclosure"
import { Menu } from "lucide-react"
import { usePathname } from "next/navigation"
import * as React from "react"
import { SidebarLinks } from "./sidebar-links"

interface Props {
  disabledFeatures: string[]
}

export function MobileSidebar({ disabledFeatures }: Props) {
  const pathname = usePathname()
  const sidebarProps = useDisclosure()
  React.useEffect(() => {
    sidebarProps.onClose()
  }, [pathname])
  return (
    <Drawer
      {...sidebarProps}
      trigger={
        <IconButton
          className="mx-2 flex rounded-full md:hidden"
          aria-label="open sidebar"
          icon={<Menu size={16} />}
          variant="ghost"
        />
      }
    >
      <SidebarLinks disabledFeatures={disabledFeatures} />
    </Drawer>
  )
}
